import React from 'react'
import { Table, TableContainer, TableHead, TableRow, Paper, TableBody, Typography,Box } from '@mui/material'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import { styled } from '@mui/material/styles';
import globalStyles from '../../utils/globalStyles'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap',
    minWidth: '220px',
    width:'200px'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    width:'220px',
    minWidth:'220px',
    padding: globalStyles.common.infoTablesPadding
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function ItemsList(props) {
  const [itemsList, setItemsList] = React.useState(props.data)
  const [creditData, setCreditData] = React.useState(props.creditData)
  const [ecomData,setEcomData] = React.useState(props.ecomData);
  const [bundleData,setBundleData] = React.useState([]);
  React.useEffect(()=>{
    const bundles = [];
    props.data && props.data.forEach((elem)=>{
      if(elem.product_type==="bundle"){
        bundles.push(elem);
      }
    });
    setBundleData(bundles);

  },[])
  const bundleNameHandler = (name, sku, oracle_id) =>{
    return `${name}` + "\n" + `${sku}` + "\n" + `${oracle_id}`;
  }
  return (
    <>
    {}
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700,width: 0 }} aria-label="customized table" hidden={bundleData.length<1}>
        <TableHead>
          <TableRow>
          <StyledTableCell align="center">Bundle-sku/Bundle name</StyledTableCell>
          <TableRow >
            <StyledTableCell align="center">Ecom-ID</StyledTableCell>
            <StyledTableCell align="center">ID</StyledTableCell>
            <StyledTableCell align="center">Product</StyledTableCell>
            <StyledTableCell align="center">Price</StyledTableCell>
            <StyledTableCell align="center" >Quantity</StyledTableCell>
            <StyledTableCell align="center">Gift Product</StyledTableCell>
            {/* <StyledTableCell align="center">Mage ID</StyledTableCell> */}
          </TableRow>
          </TableRow>
        </TableHead>
        <TableBody>
          <Box sx={{ width: '95%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px', paddingTop: '10px' }}>
          <Typography variant='h7' color='#2b3f7a'>
            Bundled Products
          </Typography>
          </Box>
          {bundleData && bundleData.length && bundleData.map((bundle)=>{
            return(
             <StyledTableRow sx={{borderBottom: '1px solid #000'}} key={bundle.sku}>
                  <StyledTableCell align="left" sx={{borderBottom: '1px solid #000'}}>{bundleNameHandler(bundle.name, bundle.sku, bundle.oracle_id)}<br></br></StyledTableCell>
                  {bundle.bundleOrderedItems &&bundle.bundleOrderedItems.length && bundle.bundleOrderedItems.map((item) => {
                    const refund = creditData != null ? creditData.find(data => data.id === item.id && parseFloat(data.qtyRefund) > 0) : null
                    return (
                      <>
                        {item.referenceId !== null && item.product_type!=="bundle"? 
                        <StyledTableRow>
                            <StyledTableCell align="left">{item.item_sku}</StyledTableCell>
                            <StyledTableCell sx={{'& .MuiTypography-root': { fontSize: '14px',overflowX: 'auto',width:'170px' } }}>
                              <Typography variant='h6' align="left">ID: {item.id}</Typography>
                              <Typography variant='h6' align="left">SKU: {item.sku}</Typography>
                            </StyledTableCell>
                            <StyledTableCell  sx={{'& .MuiTypography-root': { fontSize: '14px',overflowX: 'auto',width:'170px' } }} align="left">{item.name}</StyledTableCell>
                            <StyledTableCell align="center">SAR {item.price_incl_tax}</StyledTableCell>
                            <StyledTableCell sx={{ display: 'flex', flexDirection: 'column', '& .MuiTypography-root': { fontSize: '14px',padding:'25px' } }}>
                              <Typography variant='h6' align="center">Ordered: {item.quantity}</Typography>
                              {
                                refund != null && <Typography variant='h6' align="left">Refunded: {refund.qtyRefund}</Typography>
                              }
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <Typography align="center">
                                {item.is_gift_product === 1 ? "True" : "False"}
                              </Typography>
                            </StyledTableCell>
                            {/* <StyledTableCell>{item.mageId}</StyledTableCell> */}
                        </StyledTableRow>:<></>}
                      </>
                    )})}
              </StyledTableRow>)
          })}
          
        </TableBody>
      </Table>
    </TableContainer>
    <Box sx={{ width: '95%', marginBottom: '20px', paddingBottom: '20px', paddingTop: '20px' }}>
    </Box>
    <TableContainer>
    <Table sx={{ minWidth: 700,width:0 }}>
        <TableHead>
          <TableRow>
            <StyledTableCell align="center">Ecom-ID</StyledTableCell>
            <StyledTableCell align="center">ID</StyledTableCell>
            <StyledTableCell align="center">Product</StyledTableCell>
            <StyledTableCell align="center">Price</StyledTableCell>
            <StyledTableCell align="center">Quantity</StyledTableCell>
            <StyledTableCell align="center">Gift Product</StyledTableCell>

          </TableRow>
        </TableHead>
        <TableBody>
        <Box sx={{ width: '95%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px', paddingTop: '10px' }}>
          <Typography variant='h7' color='#2b3f7a'>
            Non-Bundled Products
          </Typography>
        </Box>
        {itemsList.map((item) => {
            const refund = creditData != null ? creditData.find(data => data.id === item.id && parseFloat(data.qtyRefund) > 0) : null
            return (
              <StyledTableRow key={item.id}>
                {item.product_type !=="bundle" && item.referenceId ===null ?  <>
                <StyledTableCell align="left">{item.item_sku}</StyledTableCell>
                <StyledTableCell sx={{'& .MuiTypography-root': { fontSize: '14px' } }}>
                  <Typography variant='h6' align="left">ID: {item.id}</Typography>
                  <Typography variant='h6' align="left">SKU: {item.sku}</Typography>
                </StyledTableCell>
                <StyledTableCell sx={{}} align="left">{item.name}</StyledTableCell>
                <StyledTableCell align="center">SAR {item.price_incl_tax}</StyledTableCell>
                <StyledTableCell sx={{ display: 'flex', flexDirection: 'column', '& .MuiTypography-root': { fontSize: '14px',padding:'25px'} }}>
                  <Typography variant='h6' align="center">Ordered: {item.quantity}</Typography>
                  {
                    refund != null && <Typography variant='h6' align="left">Refunded: {refund.qtyRefund}</Typography>
                  }
                </StyledTableCell>
                <StyledTableCell>
                <Typography  align="center">{item.is_gift_product === 1 ? "True" : "False"}</Typography>
               
                  </StyledTableCell>
          </>:<></>}
              </StyledTableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
    </>
  )
}

export default ItemsList